import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { verifyOTP } from "../../api/OTPApi";
import Cookies from "js-cookie"; // Import js-cookie

export const verifyOTPAsync = createAsyncThunk(
  "verifyOTP/fetch",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await verifyOTP(payload);

      return response.data; // Return the full data object
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const verifyOTPSlice = createSlice({
  name: "verifyOTP",
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: {}, // Store API response data
  },
  reducers: {
    resetVerifyOTPState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyOTPAsync.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(verifyOTPAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload; // Store the response data in state

        // Extract values from the action payload
        const customerId = state?.data?.data?.user_data?.id;
        const tokenId = state?.data?.data?.user_data?.token?.id;

        localStorage.setItem("customerId", customerId);
        Cookies.set("customerId", customerId, { expires: 7 });
        Cookies.set("token", tokenId, { expires: 7 });
      })
      .addCase(verifyOTPAsync.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload; // Store error message
      });
  },
});

export const { resetVerifyOTPState } = verifyOTPSlice.actions;
export default verifyOTPSlice.reducer;
